module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default;
   confirmationMessageDisabeld = u.isTrue(showConfirmation)? '': 'disabled';
 
    ; __append("\r\n<div class=\"prop-details\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 form-group-flex\">\r\n            <input type=\"checkbox\" name=\"showConfirmation\" value=\"showSuccess\" class=\"form-radio-group\">\r\n            <label class=\"form-group-label\">Show Success Message</label>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 nopadding-r\">\r\n            <textarea name=\"confirmationMessage\" rows=\"5\" style=\"cursor: auto; font-size: 11px; height: 70px;\" class=\"form-control\" ")
    ; __append(escapeFn(confirmationMessageDisabeld))
    ; __append("></textarea>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}